<script setup lang="ts">
const props = defineProps<{
  color: string;
}>();
</script>
<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="none"
  >
    <path
      d="M11.5 3C12.6272 3 13.7082 3.44777 14.5052 4.2448C15.3022 5.04183 15.75 6.12283 15.75 7.25C15.75 8.37717 15.3022 9.45817 14.5052 10.2552C13.7082 11.0522 12.6272 11.5 11.5 11.5C10.3728 11.5 9.29183 11.0522 8.4948 10.2552C7.69777 9.45817 7.25 8.37717 7.25 7.25C7.25 6.12283 7.69777 5.04183 8.4948 4.2448C9.29183 3.44777 10.3728 3 11.5 3ZM11.5 20C11.5 20 20 20 20 17.875C20 15.325 15.8562 12.5625 11.5 12.5625C7.14375 12.5625 3 15.325 3 17.875C3 20 11.5 20 11.5 20Z"
      :fill="color"
    />
    <circle cx="21.5" cy="4.5" r="2.5" fill="#BC3493" />
  </svg>
</template>
